<div class="acc-specialists-view-part">
	<grid-content [setup]="setup" [namedSize]="'TabContent'" [pageTabsGridSize]="pageTabsGridSize()"
		[rows]="accSpecialists()"></grid-content>
</div>